import { HTTP_ARIN } from "@/axios_arin.js"

export default {
    login: (data) => {
        // ไม่ต้องส่ง Authorization header ตอน login เพราะยังไม่มี token
        return HTTP_ARIN.post('/auth/login', data)
        .then(response => response)
        .catch(error => {
            // จัดการ error และ throw ต่อเพื่อให้ component จัดการได้
            throw error;
        })
    },

    profile: (data) => {
        // NOTE: ฟังก์ชันนี้ไม่ได้ถูกเรียกใช้จาก ArinLogin.vue ในปัจจุบัน
        // แต่ปรับรูปแบบให้ถูกต้องไว้เผื่อใช้ในอนาคต
        return HTTP_ARIN.get('/profile/detail', {
          headers: { Authorization: `Bearer ${data}` }
        }).then(response => response)
    },
}